<template>
  <div class="row">
    <div class="table-responsive col-lg-12">
      <table class="table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Departments</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="user in users" v-show="user.show" :key="user.id" :style="!user.active ? 'background-color: #FFDFDDFF' : ''">
          <td>
            <router-link :to="'/admin/user/' + user.id" :style="!user.active ? 'text-decoration: line-through;' : ''">{{ user.name || user.username }}</router-link>
            <i v-if="user.master" class="fa fa-star red" v-tooltip="'Master Admin'"></i>
            <i v-else-if="user.admin" class="fa fa-star orange" v-tooltip="'Admin'"></i>
          </td>
          <td>{{ user.email }}</td>
          <td>
            <i v-if="user.master" class="fa fa-star red" v-tooltip="'Master Admin'"></i>
            <i v-else-if="user.admin" class="fa fa-star orange" v-tooltip="'Admin'"></i>
            <span class="label label-danger m-r-xs" v-for="dep in user.departments" :key="'dep-' + user.id + dep">{{ dep }}</span>
            <span class="label label-primary m-r-xs" v-for="role in user.roles" :key="'role-' + user.id + role">R: {{ role }}</span>
            <span class="label label-info m-r-xs" v-for="cli in user.clients" :key="'cli-' + user.id + cli.name">C: {{ cli.name }}</span>
            <span class="label label-success m-r-xs" v-for="g in user.groups" :key="'gr-' + user.id + g.name">G: {{ g.name }}</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      users: 'getUsers'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Users/List.vue